<section class="p-6">

  <!-- Account Tabs -->
  <app-account-tabs></app-account-tabs>

  <div class="md:h-[36rem] md:min-h-[36rem]">

    <div *ngIf="!isLoading && !addBillingCompany && !hasBillingProfile" class="flex justify-center items-center h-full">
      <div class="text-center">
        <h3 class="mt-2 font-semibold text-secondary">Company Billing</h3>
        <p class="mt-1 text-sm text-gray-500">If you want to be invoiced as a company, click Add Company Billing.</p>
        <div class="mt-6 flex justify-center">
          <button type="button" (click)="handleAddCompanyBilling()" class="btn btn-blue flex items-center">
            <svg class="-ml-0.5 mr-1.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
            </svg>
            Add Company Billing
          </button>
        </div>

      </div>

    </div>

    <form *ngIf="!isLoading && addBillingCompany" [formGroup]="form" (submit)="updateBillingProfile()" method="POST" class="space-y-6">

      <div *ngIf="addBillingCompany && !hasBillingProfile" class="mt-6"></div>

      <div class="space-y-6">

        <div *ngIf="hasBillingProfile" class="mt-6 pb-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 bg-white border-b border-gray-200">
          <div class="col-span-12">

            <div class="text-sm flex justify-between items-center">
              <label class="font-medium leading-6 text-secondary-900">
                You are billed as a company.
              </label>

              <button type="button" (click)="openCancelCompanyBillingModal()" class="btn btn-danger">
                Cancel company billing
              </button>
            </div>

          </div>
        </div>

        <div *ngIf="isCompany && addBillingCompany" class="grid grid-cols-2 gap-6">

          <div class="col-span-2 md:col-span-1">
            <div class="flex justify-start">
              <label for="company_name" class="block text-sm font-medium leading-6 text-gray-900">Company name</label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <div class="mt-2">
              <input id="company_name" formControlName="company_name" type="text" [required]="isCompany" class="input" [class.border-red-500]="form.get('company_name').touched && form.get('company_name').invalid">
            </div>
            <div class="pt-1" *ngIf="form.get('company_name').touched && form.get('company_name').invalid">
              <p *ngIf="form.get('company_name').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                Company name is required
              </p>
              <p *ngIf="form.get('company_name').errors?.['minlength']" class="text-sm text-red-600 dark:text-red-400">
                Company name must be at least 2 characters long
              </p>
              <p *ngIf="form.get('company_name').errors?.['maxlength']" class="text-sm text-red-600 dark:text-red-400">
                Company name cannot exceed 255 characters
              </p>
              <p *ngIf="form.get('company_name').errors?.['whitespace']" class="text-sm text-red-600 dark:text-red-400">
                Company name cannot be only spaces
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-1">
            <div class="flex justify-start">
              <label for="company_vat" class="block text-sm font-medium leading-6 text-gray-900">Company Indentifier <span class="italic dark:text-primary-200">(VAT Code)</span></label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <div class="mt-2">
              <input id="company_vat" formControlName="company_vat" type="text" [required]="isCompany" class="input" [class.border-red-500]="form.get('company_vat').touched && form.get('company_vat').invalid">
            </div>
            <div class="pt-1" *ngIf="form.get('company_vat').touched && form.get('company_vat').invalid">
              <p *ngIf="form.get('company_vat').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                VAT is required
              </p>
              <p *ngIf="form.get('company_vat').errors?.['minlength']" class="text-sm text-red-600 dark:text-red-400">
                VAT must be at least 2 characters long
              </p>
              <p *ngIf="form.get('company_vat').errors?.['maxlength']" class="text-sm text-red-600 dark:text-red-400">
                VAT cannot exceed 50 characters
              </p>
              <p *ngIf="form.get('company_vat').errors?.['whitespace']" class="text-sm text-red-600 dark:text-red-400">
                VAT cannot be only spaces
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-1">
            <div class="flex justify-start">
              <label for="company_country_id" class="block text-sm font-medium leading-6 text-gray-900">Country</label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <select id="company_country_id" name="company_country_id" formControlName="company_country_id" [required]="isCompany" class="input mt-2" [class.border-red-500]="form.get('company_country_id').touched && form.get('company_country_id').invalid">
              <option value="" selected>Select country</option>
              <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
            </select>
            <div class="pt-1" *ngIf="form.get('company_country_id').touched && form.get('company_country_id').invalid">
              <p *ngIf="form.get('company_country_id').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                Country is required
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-1">
            <div class="flex justify-start">
              <label for="company_county" class="block text-sm font-medium leading-6 text-gray-900">State / County</label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <div class="mt-2">
              <input id="company_county" formControlName="company_county" type="text" [required]="isCompany" class="input" [class.border-red-500]="form.get('company_county').touched && form.get('company_county').invalid">
            </div>
            <div class="pt-1" *ngIf="form.get('company_county').touched && form.get('company_county').invalid">
              <p *ngIf="form.get('company_county').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                State / County is required
              </p>
              <p *ngIf="form.get('company_county').errors?.['minlength']" class="text-sm text-red-600 dark:text-red-400">
                State / County must be at least 2 characters long
              </p>
              <p *ngIf="form.get('company_county').errors?.['maxlength']" class="text-sm text-red-600 dark:text-red-400">
                State / County cannot exceed 100 characters
              </p>
              <p *ngIf="form.get('company_county').errors?.['whitespace']" class="text-sm text-red-600 dark:text-red-400">
                State / County cannot be only spaces
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-1">
            <div class="flex justify-start">
              <label for="company_town" class="block text-sm font-medium leading-6 text-gray-900">City</label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <div class="mt-2">
              <input id="company_town" formControlName="company_town" type="text" [required]="isCompany" class="input" [class.border-red-500]="form.get('company_town').touched && form.get('company_town').invalid">
            </div>
            <div class="pt-1" *ngIf="form.get('company_town').touched && form.get('company_town').invalid">
              <p *ngIf="form.get('company_town').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                City is required
              </p>
              <p *ngIf="form.get('company_town').errors?.['minlength']" class="text-sm text-red-600 dark:text-red-400">
                City must be at least 2 characters long
              </p>
              <p *ngIf="form.get('company_town').errors?.['maxlength']" class="text-sm text-red-600 dark:text-red-400">
                City cannot exceed 100 characters
              </p>
              <p *ngIf="form.get('company_town').errors?.['whitespace']" class="text-sm text-red-600 dark:text-red-400">
                City cannot be only spaces
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-1">
            <div class="flex justify-start">
              <label for="company_zip_code" class="block text-sm font-medium leading-6 text-gray-900">Zip Code</label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <div class="mt-2">
              <input id="company_zip_code" formControlName="company_zip_code" type="text" [required]="isCompany" class="input" [class.border-red-500]="form.get('company_zip_code').touched && form.get('company_zip_code').invalid">
            </div>
            <div class="pt-1" *ngIf="form.get('company_zip_code').touched && form.get('company_zip_code').invalid">
              <p *ngIf="form.get('company_zip_code').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                Zip Code is required
              </p>
              <p *ngIf="form.get('company_zip_code').errors?.['minlength']" class="text-sm text-red-600 dark:text-red-400">
                Zip Code must be at least 2 characters long
              </p>
              <p *ngIf="form.get('company_zip_code').errors?.['maxlength']" class="text-sm text-red-600 dark:text-red-400">
                Zip Code cannot exceed 20 characters
              </p>
              <p *ngIf="form.get('company_zip_code').errors?.['whitespace']" class="text-sm text-red-600 dark:text-red-400">
                Zip Code cannot be only spaces
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-2">
            <div class="flex justify-start">
              <label for="company_address" class="block text-sm font-medium leading-6 text-gray-900">Address</label>
              <span class="font-semibold text-red-500 pl-1">*</span>
            </div>
            <div class="mt-2">
              <input id="company_address" formControlName="company_address" type="text" [required]="isCompany" class="input" [class.border-red-500]="form.get('company_address').touched && form.get('company_address').invalid">
            </div>
            <div class="pt-1" *ngIf="form.get('company_address').touched && form.get('company_address').invalid">
              <p *ngIf="form.get('company_address').errors?.['required']" class="text-sm text-red-600 dark:text-red-400">
                Address is required
              </p>
              <p *ngIf="form.get('company_address').errors?.['minlength']" class="text-sm text-red-600 dark:text-red-400">
                Address must be at least 5 characters long
              </p>
              <p *ngIf="form.get('company_address').errors?.['maxlength']" class="text-sm text-red-600 dark:text-red-400">
                Address cannot exceed 255 characters
              </p>
              <p *ngIf="form.get('company_address').errors?.['whitespace']" class="text-sm text-red-600 dark:text-red-400">
                Address cannot be only spaces
              </p>
            </div>
          </div>

          <div class="col-span-2 md:col-span-2">
            <div class="flex items-center">
              <label for="toggle-vat-payer" class="flex items-center cursor-pointer relative mb-2">
                <input type="checkbox" formControlName="company_is_vat_payer" id="toggle-vat-payer" class="sr-only">
                <div class="toggle-bg bg-gray-200 border-2 border-gray-200 h-6 w-11 rounded-full"></div>
                <div class="text-sm font-medium leading-6 text-gray-900 dark:text-primary-200 ml-3">VAT Payer</div>
              </label>
            </div>
            <span class="text-xs text-gray-500 dark:text-primary-200">Toggle this button if you are a VAT payer in EU.</span>
          </div>
        </div>

      </div>

      <div *ngIf="isCompany && addBillingCompany" class="flex justify-end my-6 mb-5">

        <div class="flex items-center justify-end gap-x-3">
          <button (click)="router.navigate(['/settings/account'])" type="button" class="btn btn-cancel">
            Cancel
          </button>
          <button type="submit" *ngIf="hasBillingProfile" class="btn btn-blue">
            Update Company Billing
          </button>
          <button type="submit" *ngIf="!hasBillingProfile" class="btn btn-blue">
            Create Company Billing
          </button>
        </div>

      </div>

    </form>

  </div>

  <div *ngIf="isCancelCompanyBillingVisible" class="relative z-20" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">

          <form [formGroup]="form" (submit)="onCancelCompanyBilling()" method="POST">

            <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-transparent focus:ring-offset-2">
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Cancel company billing</h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500 mb-3">
                      When company billing is canceled, future invoices will revert to being billed directly to the individual.
                      This change ensures that all subsequent payments and invoices will be addressed to the person rather than the company.
                      Please update your records accordingly to reflect this adjustment.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button type="submit" class="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Cancel company billing</button>
              <button type="button" (click)="closeModal()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button>
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>

</section>
